import { default as _91_46_46_46slug_93xWSehfewgOMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/[...slug].vue?macro=true";
import { default as _404gcG1P97pYnMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/404.vue?macro=true";
import { default as indexGjCoPGBUwRMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedanktHR0JkOmlzHMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_935mmUunRFoUMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/contact/[slug].vue?macro=true";
import { default as indexiMfPwLb4SxMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/contact/index.vue?macro=true";
import { default as index4ovRdAyMpFMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93cLyzjjhfu4Meta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexSbq0mjEztdMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieUVwL42OBmlMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_93zTFJkgNrLAMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93CwBFAm1jBgMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexAeNBL2eKAfMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93GTPxoY52n0Meta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_930tFJ2VcKPnMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93z6sF9P2t40Meta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93LMpa02x2AuMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as indexNq2T0pAAHoMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenM1jQWHGwOXMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_930Dc3FoDDH5Meta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedankt0iacH0VjatMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faqTMPs2C4KUbMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningzwP6lk3vWnMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijzeEyTWaWr5ckMeta } from "/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93xWSehfewgOMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexGjCoPGBUwRMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedanktHR0JkOmlzHMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_935mmUunRFoUMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexiMfPwLb4SxMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: index4ovRdAyMpFMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93cLyzjjhfu4Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexSbq0mjEztdMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieUVwL42OBmlMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_93zTFJkgNrLAMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexAeNBL2eKAfMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93GTPxoY52n0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_930tFJ2VcKPnMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93z6sF9P2t40Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93LMpa02x2AuMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: indexNq2T0pAAHoMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenM1jQWHGwOXMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_930Dc3FoDDH5Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faqTMPs2C4KUbMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/22/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]